import GoDiagramWrapper from './Go-diagram-wrapper/GoDiagramWrapper'
import ReactECharts from 'echarts-for-react'
import styles from './ProcessDiagram.module.scss'

export const ProcessDiagram = ({
    diagramState,
    getOptionWithStyles,
    getSankeyTheme,
    isOpenRightPanel,
    isOpenLeftPanel,
    isRenderedInACanvas,
    pointerEvents,
}) => {
    const containerClasses = [
        styles.container,
        !diagramState.isSankey && styles.diagramContent,
        !isRenderedInACanvas && isOpenLeftPanel && styles.leftOpen,
        !isRenderedInACanvas && isOpenRightPanel && styles.rightOpen,
    ]
        .filter(Boolean)
        .join(' ')

    const getWidth = () => {
        if (isRenderedInACanvas) {
            return '100%'
        }
        return `calc(100% - ${isOpenLeftPanel ? '300px' : '0px'} - ${isOpenRightPanel ? '300px' : '0px'})`
    }

    return (
        <div className={containerClasses}>
            {diagramState.isSankey ? (
                <ReactECharts
                    key={diagramState.sankeyKey || diagramState.key}
                    option={getOptionWithStyles()}
                    notMerge={true}
                    lazyUpdate={true}
                    style={{
                        height: window.innerHeight - 120 + 'px',
                        pointerEvents: pointerEvents,
                    }}
                    theme={getSankeyTheme()}
                />
            ) : (
                <GoDiagramWrapper
                    customStyles={{
                        width: getWidth(),
                    }}
                    key={`${diagramState.theme?.themeID || diagramState.theme}-${diagramState.nodeColor}`}
                    {...diagramState}
                    theme={
                        diagramState.theme === 'None' && diagramState.nodeColor
                            ? {
                                  colorScheme: {
                                      colors: [
                                          { val: diagramState.nodeColor },
                                          { val: '#1e6e53' },
                                          { val: '#1e6e53' },
                                          { val: '#1e6e53' },
                                          { val: '#473766' }, // Color for stroke (index 4)
                                      ],
                                  },
                              }
                            : diagramState.theme
                    }
                />
            )}
        </div>
    )
}
